export function serializeToString(obj: object): { [key: string]: string } {
    return Object.keys(obj).reduce((result, key) => {
        if (obj[key] !== null && obj[key] !== undefined) {
            if (typeof obj[key] !== 'object') {
                Object.assign(result, { [key]: obj[key].toString() });
            } else {
                Object.assign(result, { [key]: obj[key] });
            }
        }

        return result;
    }, {});
}
